import { Notice, NoticeFactory } from '@b2b/common/factories/notice';
import { AddressService, AddressServiceModule } from '@b2b/common/services/address';
import { CustomerService, CustomerServiceModule } from '@b2b/common/services/customer';
import { Address, AddressType, TODO } from '@b2b/types/core';
import angular, { ITimeoutService } from 'angular';

VCardEditCardholderDirective.$inject = [
  '$timeout',
  'ValidateService',
  'AddressService',
  'CustomerService',
  'NoticeFactory',
];

function VCardEditCardholderDirective(
  $timeout: ITimeoutService,
  ValidateService: TODO,
  AddressService: AddressService,
  CustomerService: CustomerService,
  NoticeFactory: NoticeFactory
) {
  VCardEditCardholderController.$inject = ['$scope'];

  function VCardEditCardholderController($scope: TODO) {
    const ctrl = {
      notice: new NoticeFactory() as Notice,
      metadata: {} as {
        isAutorenewMembership?: boolean;
        onMakePrimaryClick?({ event, notice }: { event: PointerEvent; notice: Notice }): void;
      },
      userEnteredInfo: null as TODO | null,

      selectedAddress: {} as Partial<Address>,
      address: {} as Partial<Address>,
      addressType: 'existing' as AddressType,

      addresses: [] as Address[],

      addressHeaderTitle: 'Contact Info',

      addressTitles: [] as TODO[],

      errors: {} as Record<string, { message: string }>,
      selectedTitle: false as TODO | false,
      makePrimary: false,

      uiState: {
        alerts: 'default' as 'default' | 'secondary_with_existing_customer' | 'autorenew',
      },

      titles: [] as { title: string; name: string }[],

      cardTypes: [
        {
          cardType: 'primary',
          name: 'Primary',
        },
        {
          cardType: 'secondary',
          name: 'Secondary',
        },
      ],

      newAddress: {
        id: 'new',
        name: '+ New Address',
      },

      noAddress: {
        id: 'none',
        name: 'None',
      },

      submitted: false,
      isEditingAddress: false,
      trackNameOnCard: false,

      init: function () {
        ctrl.metadata = $scope.metadata;

        ctrl.setSettings();

        if (!$scope.model.name) {
          ctrl.trackNameOnCard = true;
        }

        if (ctrl.hasSelectedExistingCustomer()) {
          ctrl.addressHeaderTitle = 'Customer Info';
          ctrl.userEnteredInfo = $scope.modelMeta.originalCardholder;
          if (ctrl.userEnteredInfo) {
            ctrl.userEnteredInfo.fullName = ctrl.getFullName(ctrl.userEnteredInfo);
          }
        }

        ctrl.selectTitle();

        ctrl.selectAddress();

        ctrl.addresses = ctrl.getAddresses();

        ctrl.addressTitles = ctrl.addresses.map((address) => {
          return Object.assign({}, { id: address.id || false }, address);
        });

        ctrl.checkAddress();

        if ($scope.addressHeaderTitle) {
          ctrl.addressHeaderTitle = $scope.addressHeaderTitle;
        }

        ctrl.processUiState();

        $scope.$on('VcardCardholder::Process', ctrl.onProcess);
        $scope.$on('AddressCreate::Complete', ctrl.onAddressCreateComplete);
        $scope.$on('AddressCreate::Error', ctrl.onAddressCreateError);
      },

      setSettings: function () {
        ctrl.titles = CustomerService.getTitles();
      },

      hasSelectedExistingCustomer: function () {
        return $scope.modelMeta && !!$scope.modelMeta.match;
      },

      getFullName: function (cardholder) {
        return [cardholder.prefix, cardholder.firstName, cardholder.middleName, cardholder.lastName]
          .filter(function (name) {
            return !!name;
          })
          .join(' ');
      },

      selectAddress: function () {
        if ($scope.model.address) {
          $scope.model.address = AddressService.getFormattedAddress($scope.model.address);
        }

        ctrl.selectedAddress = $scope.model.address || null;
      },

      selectTitle: function () {
        if ($scope.model.prefix) {
          ctrl.selectedTitle = CustomerService.getSalutationName($scope.model.prefix);
        }
      },

      processUiState: function () {
        function getUiAlertsState() {
          if (ctrl.isCardType('primary') && ctrl.metadata.isAutorenewMembership) {
            return 'autorenew';
          } else if (ctrl.isCardType('secondary') && ctrl.hasSelectedExistingCustomer()) {
            return 'secondary_with_existing_customer';
          }

          return 'default';
        }

        ctrl.uiState = {
          alerts: getUiAlertsState(),
        };
      },

      getAddresses: function () {
        let addresses: TODO[] = [];
        let found: Address | null = null;

        if (Array.isArray($scope.addresses)) {
          addresses = [].concat($scope.addresses);
        }

        if (ctrl.selectedAddress) {
          found = AddressService.isDuplicateAddress(ctrl.selectedAddress, addresses);
          if (found) {
            ctrl.selectedAddress = found;
          }
        }

        addresses.unshift({
          id: ctrl.newAddress.id,
          name: ctrl.newAddress.name,
        });

        addresses.unshift({
          id: ctrl.noAddress.id,
          name: ctrl.noAddress.name,
        });

        if (!ctrl.selectedAddress || !found) {
          ctrl.selectedAddress = addresses[0];
          ctrl.addressType = 'none';
        }

        return addresses;
      },

      editAddress: function () {
        ctrl.addressType = 'edit';
        ctrl.address = ctrl.selectedAddress;
        ctrl.isEditingAddress = true;
      },

      isCardType: function (type) {
        return $scope.model && $scope.model.cardType && $scope.model.cardType === type;
      },

      marshalCardholder: function () {
        ctrl.updateCardholderAddress();
        ctrl.updateCardType();
        $scope.model.customerSource = $scope.model.customerSource || 'acme';
      },

      updateCardholderAddress: function () {
        const discardProps = ['name', 'prevName'];

        const addressId = ctrl.addressType === 'existing' ? ctrl.address.id || undefined : undefined;
        $scope.model.address = AddressService.getUnFormattedAddress(ctrl.address);

        if (ctrl.isAddressType('edit')) {
          $scope.model.address.prevName = ctrl.selectedAddress.name;
        } else {
          $scope.model.address.prevName = false;
        }

        if ($scope.model.address) {
          for (const key in $scope.model.address) {
            if ($scope.model.address.hasOwnProperty(key) && !discardProps.includes(key)) {
              $scope.model[key] = $scope.model.address[key];
            }
          }

          $scope.model.addressId = addressId;
          $scope.model.address.id = addressId;
        }
      },

      updateCardType: function () {
        $scope.model.cardType = ctrl.isPrimaryCardholder() ? 'primary' : 'secondary';
      },

      generateNameOnCard: function () {
        const name: string[] = [];

        if ($scope.model.prefix) {
          const prefix = CustomerService.getSalutationName($scope.model.prefix);
          if (prefix) {
            name.push(prefix);
          }
        }

        if ($scope.model.firstName) {
          name.push($scope.model.firstName);
        }

        if ($scope.model.middleName) {
          name.push($scope.model.middleName);
        }

        if ($scope.model.lastName) {
          name.push($scope.model.lastName);
        }

        return name.join(' ');
      },

      copyNameOnCard: function (force = false) {
        //next tick
        $timeout(() => {
          if (force || ctrl.trackNameOnCard) {
            $scope.model.name = ctrl.generateNameOnCard();
          }
        }, 0);
      },

      nameOnCardChanged: function () {
        //next tick
        $timeout(() => {
          if (ctrl.nameOnCardDiffers()) {
            ctrl.trackNameOnCard = false;
          } else {
            ctrl.trackNameOnCard = true;
          }
        }, 0);
      },

      nameOnCardDiffers: function () {
        const nameOnCard = ctrl.generateNameOnCard();
        return $scope.model.name && nameOnCard !== $scope.model.name;
      },

      isAddressSelected: function () {
        return !ctrl.selectedAddress.id;
      },

      addressUpdated: function (props: { added: boolean; editExisting?: boolean; noAddress?: boolean }) {
        if (props.added || props.editExisting) {
          if (props.editExisting && ctrl.selectedAddress) {
            ctrl.address = AddressService.getFormattedAddress(angular.copy(ctrl.selectedAddress));
          } else {
            ctrl.address = {};
          }
          ctrl.addressType = 'new';
        } else if (props.noAddress) {
          ctrl.addressType = 'none';
          ctrl.address = {};
        } else {
          ctrl.addressType = 'existing';
        }
      },

      checkAddress: function () {
        if (!ValidateService.validate(ctrl.getValidators(true))) {
          ctrl.errors = ValidateService.getErrorHash();
        }
      },

      validateForm: function () {
        const valid = ValidateService.validate(ctrl.getValidators());
        ctrl.errors = ValidateService.getErrorHash();

        if (valid) {
          return null;
        }

        return ctrl.errors;
      },

      getValidators: function (addressOnly = false) {
        let validators: TODO[] = [];
        const contactValidators = {
          nameOnCard: addressOnly
            ? []
            : [
                {
                  field: 'vcard-edit-cardholder-name-on-card',
                  len: { message: 'Invalid name on card', test: { value: $scope.model.name } },
                },
              ],
          name: addressOnly
            ? []
            : [
                {
                  field: 'vcard-edit-cardholder-first-name',
                  len: { message: 'Invalid name', test: { value: $scope.model.firstName } },
                },
                {
                  field: 'vcard-edit-cardholder-last-name',
                  len: { message: 'Invalid name', test: { value: $scope.model.lastName } },
                },
              ],
          contact: addressOnly
            ? []
            : [
                {
                  field: 'vcard-edit-cardholder-email',
                  email: {
                    message: 'Invalid email',
                    test: function () {
                      return $scope.model.email;
                    },
                  },
                },
                {
                  field: 'vcard-edit-cardholder-phone',
                  phone: {
                    message: 'Invalid phone number',
                    test: function () {
                      return $scope.model.phoneNumber;
                    },
                  },
                },
              ],
          address: [
            {
              field: 'vcard-edit-cardholder-address',
              len: { message: ctrl.invalidAddressError(), test: { value: ctrl.validateAddress() ? '1' : '' } },
            },
            {
              field: 'vcard-edit-cardholder-new-address',
              len: { message: ctrl.invalidAddressError(), test: { value: ctrl.validateAddress() ? '1' : '' } },
            },
          ],
          optionals: [
            {
              field: 'vcard-edit-cardholder-email',
              optionalEmail: {
                message: 'Invalid email',
                test: function () {
                  return $scope.model.email;
                },
              },
            },
            {
              field: 'vcard-edit-cardholder-phone',
              optionalPhone: {
                message: 'Invalid phone number',
                test: function () {
                  return $scope.model.phoneNumber;
                },
              },
            },
          ],
          autorenew: addressOnly
            ? []
            : [
                {
                  field: 'vcard-edit-cardholder-email',
                  equal: {
                    message: 'Invalid email',
                    test: function () {
                      const cardholder = $scope.model;

                      if (ctrl.isCardType('primary') && ctrl.metadata.isAutorenewMembership) {
                        const isValidEmail = ValidateService.validators.email(cardholder.email);
                        return [isValidEmail, true];
                      }

                      return [true, true];
                    },
                  },
                },
              ],
        };

        if (ctrl.isPrimaryCardholder()) {
          validators = validators.concat(
            contactValidators.name,
            contactValidators.optionals,
            contactValidators.autorenew
          );
          if (ctrl.useValidation()) {
            validators = validators.concat(contactValidators.address, contactValidators.nameOnCard);
          }
        } else {
          // Secondary cardholder
          if (ctrl.hasSelectedExistingCustomer()) {
            const oneOfValues = [
              { value: $scope.model.email },
              { value: $scope.model.phoneNumber },
              { value: ctrl.addressType === 'none' ? false : ctrl.validateAddress() ? '1' : '' },
            ];

            validators = validators.concat(
              contactValidators.name,
              [
                {
                  field: 'vcard-edit-cardholder-email',
                  oneOf: { message: 'Invalid email', test: { values: oneOfValues } },
                },
                {
                  field: 'vcard-edit-cardholder-phone',
                  oneOf: { message: 'Invalid phone number', test: { values: oneOfValues } },
                },
                {
                  field: 'vcard-edit-cardholder-address',
                  oneOf: { message: ctrl.invalidAddressError(), test: { values: oneOfValues } },
                },
                {
                  field: 'vcard-edit-cardholder-new-address',
                  oneOf: { message: ctrl.invalidAddressError(), test: { values: oneOfValues } },
                },
              ],
              contactValidators.optionals
            );
          } else {
            validators = validators.concat(contactValidators.nameOnCard, contactValidators.optionals);
          }
        }

        return validators;
      },

      hasOneOfError: function () {
        return (
          ctrl.errors &&
          (ctrl.errors['vcard-edit-cardholder-email'] ||
            ctrl.errors['vcard-edit-cardholder-phone'] ||
            ctrl.errors['vcard-edit-cardholder-address'] ||
            ctrl.errors['vcard-edit-cardholder-new-address'])
        );
      },

      getErrorMessage: function (field) {
        return ctrl.errors && ctrl.errors[field] ? ctrl.errors[field].message : '';
      },

      checkRequired: function (field) {
        // Secondary needs only the name on card, primary needs all the basics
        if (!ctrl.isPrimaryCardholder() && field !== 'vcard-edit-cardholder-name-on-card') {
          return false;
        } else {
          return true;
        }
      },

      validateAddressSelector: function () {
        if (
          ctrl.errors['vcard-edit-cardholder-new-address'] !== undefined &&
          ctrl.errors['vcard-edit-cardholder-new-address'].message !== ' '
        ) {
          return false;
        }

        if (
          ctrl.errors['vcard-edit-cardholder-address'] !== undefined &&
          ctrl.errors['vcard-edit-cardholder-address'].message !== ' '
        ) {
          return false;
        }

        return true;
      },

      validateAddress: function () {
        // Don't revalidate an already existing address
        if (ctrl.addressType === 'existing') {
          return true;
        }

        const address = ctrl.address;
        let result = true;
        const keys = AddressService.getValidators(address);

        if (ctrl.useValidation() && address) {
          angular.forEach(keys, function (key) {
            if (result && address.hasOwnProperty(key) && address[key]) {
              result = address[key].length;
            } else {
              result = false;
            }
          });
        }

        return result;
      },

      invalidAddressError: function () {
        if (ctrl.isPrimaryCardholder() && ctrl.addressType === 'none') {
          const requiredForPrimaryCardholderMessage = 'Required for primary cardholder';

          // Validation should run immediately if we have selected an existing customer
          if (!!ctrl.userEnteredInfo) {
            return requiredForPrimaryCardholderMessage;
          }

          return ctrl.submitted ? requiredForPrimaryCardholderMessage : ' '; //this is a space intentionally - hack
        }

        return 'Invalid address';
      },

      isPrimaryCardholder: function () {
        return !!ctrl.makePrimary || ctrl.isCardType('primary');
      },

      onMakePrimaryClick: function (event: PointerEvent) {
        ctrl.metadata?.onMakePrimaryClick?.({ event, notice: ctrl.notice });
      },

      onMakePrimaryChanged: function () {
        if (ctrl.makePrimary === false) {
          ctrl.validateForm();
        }
      },

      useValidation: function () {
        return $scope.validate !== undefined && $scope.validate === 'true' && ctrl.isPrimaryCardholder();
      },

      setAddress: function () {
        if (ctrl.isAddressType('none')) {
          ctrl.address = AddressService.getUnFormattedAddress(null, true) ?? {};
        } else if (ctrl.isAddressType('existing')) {
          ctrl.address = ctrl.selectedAddress;
        }
      },

      isAddressType: function (type: AddressType) {
        return ctrl.addressType === type;
      },

      done: function () {
        if (ValidateService.validate(ctrl.getValidators())) {
          ctrl.setAddress();

          ctrl.marshalCardholder();
          $scope.$emit('VcardCardholder::Complete');
        } else {
          ctrl.errors = ValidateService.getErrorHash();
        }
      },

      onProcess: function (e, data) {
        ctrl.submitted = true;

        if (ctrl.address) {
          switch (ctrl.addressType) {
            case 'new':
            case 'edit':
              $scope.$broadcast('AddressCreate::Process');
              break;
            case 'none':
            case 'existing':
              ctrl.done();
              break;
          }
        } else {
          ctrl.done();
        }
      },

      onAddressCreateComplete: function (e, data) {
        ctrl.address = data.address;
        ctrl.done();
      },

      onAddressCreateError: function (e, data) {},

      onTitleChange: function (e, data) {
        $scope.model.prefix = ctrl.selectedTitle.title;
        ctrl.copyNameOnCard();
      },

      onAddressSelected: function (e, data) {
        ctrl.errors = {};

        ctrl.isEditingAddress = false;

        if (ctrl.selectedAddress.id === ctrl.newAddress.id) {
          ctrl.addressUpdated({ added: true });
        } else if (ctrl.selectedAddress.id === ctrl.noAddress.id) {
          ctrl.addressUpdated({ added: false, editExisting: false, noAddress: true });
        } else {
          ctrl.addressUpdated({ added: false });
        }
      },
    };

    $scope.vcardEditCardholder = ctrl;
    ctrl.init();
  }

  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/vcard/edit/cardholder/cardholder.tpl.html',
    scope: {
      model: '=',
      modelMeta: '=',
      mode: '=',
      addressHeaderTitle: '@',
      addresses: '=',
      validate: '@',
      showSearch: '=',
      metadata: '<',
    },

    link: function ($scope, $element, $attrs) {
      // Modified after controller runs
    },

    controller: VCardEditCardholderController,
  };
}

export const VCardEditCardholderDirectiveModule = angular
  .module('acme.common.directive.vcardEditCardholder', [
    'acme.common.service.validate',
    'acme.common.factory.notice',
    AddressServiceModule,
    CustomerServiceModule,
  ])
  .directive('vcardEditCardholder', VCardEditCardholderDirective).name;
